import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { ModalService } from '../../../../../../services/modal.service';
import { Materials } from '../../../../../../models/materials';
import { DatePipe, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-book-additionals',
    templateUrl: './book-additionals.component.html',
    styleUrls: ['./book-additionals.component.scss'],
    imports: [
        DatePipe,
        NgTemplateOutlet
    ],
    standalone: true
})
export class BookAdditionalsComponent {

    constructor(
        public applicationStateService: ApplicationStateService,
        private modalService: ModalService
    ) {
    }

    openDisabledMaterialModal(): void {
        this.modalService.closeModal(Materials.MODAL_ID);
        this.modalService.openDisabledMaterialModal();
    }
}
